"use strict";

//
// All component javascript libraries should be included here as the
// demo component has been included for example.
// As the demo component is just included for demonstration purposes it should
// be removed at some point.
//
const { Video } = require("../components/01-elements/video/video");
import initializeNavigation from "../components/02-components/navigation/navigation";
import initializeHero from "../components/02-components/hero/hero";
import initializeHeroLvl3 from "../components/02-components/hero/heroLvl3";
import initializeModal from "../components/02-components/modal/modal";
import initializeCustomerVoices from "../components/02-components/customer-voice/customer-voice";
import initializeCaseStudyTeaser from "../components/02-components/case-study-teaser/case-study-teaser";
import initializeCaseStudyOverview from "../components/02-components/case-study-overview/case-study-overview";
import initializeNewsOverview from "../components/02-components/news-overview/news-overview";
import initializeForm from "../components/02-components/form/form";
import initializeCalculator from "../components/02-components/calculator/calculator";
import eTrackerDataLayer from "../components/04-tracking/eTrackerDataLayer";
import lenisInit from "../components/07-libs/lenis";
import gsapInit from "../components/07-libs/gsap";

//
// Below is the main jQuery function that gets called as soon as the DOM is
// ready. Yes, the use of jQuery is allowed and you are encouraged to use it.
// The main function call below is analog to the now deprecated
// $(document).ready() function call used in earlier jQuery versions.
// Please also remove the Demo method calls at some point as they are only
// mentioned here for demonstration purposes.
//
jQuery(function ($) {
  Video.init();
  initializeNavigation();
  initializeHero();
  initializeHeroLvl3();
  initializeModal();
  initializeCustomerVoices();
  initializeCaseStudyTeaser();
  initializeCaseStudyOverview();
  initializeNewsOverview();
  initializeForm();
  initializeCalculator();
  eTrackerDataLayer();
  lenisInit();
  gsapInit();
});
